import {AgentContext} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';
import {ContentFeed, ContentFeedType} from 'common/src/modules/contentFeeds/contentFeeds.types';
import routingService from 'common/src/modules/routing/routing.service';
import {RouteKey} from 'common/src/modules/routing/routing.enums';

type ContentFeedExternalContextData = {
  feed: ContentFeed;
  currentStep: string;
};

function getStepLabel(routeKey: RouteKey | undefined): string {
  switch (routeKey) {
    case RouteKey.ContentFeedPage:
      return 'Homepage';
    case RouteKey.ContentFeedMapping:
      return 'Mapping';
    case RouteKey.ContentFeedItems:
      return 'Items';
    case RouteKey.ContentFeedSets:
      return 'Content sets';
    default:
      return routeKey ? String(routeKey) : 'Unknown';
  }
}

export default function contentFeedExternalContext(
  store: CLStore,
): AgentContext<ContentFeedExternalContextData | null> {
  return {
    title: 'Content feed (external)',
    getter: (): ContentFeedExternalContextData | null => {
      const state = store.getState();
      const feed = state.contentFeedPage?.feed;

      if (!feed || feed.type === ContentFeedType.AiGenerated) {
        return null;
      }

      const route = routingService.getCurrentRouteWithParams();

      return {
        feed,
        currentStep: getStepLabel(route?.routeKey),
      };
    },
    formatter: ({currentContext}) => {
      if (currentContext == null) {
        return null;
      }

      const {feed, currentStep} = currentContext;

      const lines = [
        `## Content Feed (Type=From External SpreadSheet): ${feed.name} (ID: ${feed.id})`,
        `Current workflow step: ${currentStep}`,
        `- Items count (inventory): ${feed.itemsCount}`,
      ];

      return lines.join('\n');
    },
  };
}
